import _ from 'lodash';


function isWide(index) {
  return _.includes([0, 5, 6, 10, 14, 15], index);
}

export function transformForHomePage(categories) {
  const result = [];
  categories.forEach((category, index) => {
    result.push({
      type: category.type,
      slug: category.path,
      name: isWide(index) && (category.titlePart1 && category.titlePart2) ?
      `${category.titlePart1} ${category.titlePart2}` :
        category.name,
      smallText: !isWide(index) ?
        category.titlePart1 :
        undefined,
      bigText: !isWide(index) ?
        category.titlePart2 :
        undefined,
      hover: category.description,
      cta: category.callToAction,
      categoryBackgroundImage: category.images.pageBackground,
      headerColor: category.colors.header,
      headerImage: category.images.pageHeader,
      backgroundColor: category.colors.background,
      backgroundImage: isWide(index) ?
        category.images.wideBackground :
        category.images.squareBackground,
      hoverBackgroundColor: category.colors.hoverBackground,
      hoverBackgroundImage: isWide(index) ?
        category.images.hoverWideBackground :
        category.images.hoverSquareBackground,
      appsCount: category.appCount
    });
  });
  return result;
}

export function transformForMenu(categories) {
  const result = [];
  categories.forEach((category, index) => {
    const obj = {
      type: category.type,
      slug: category.path,
      name: category.name,
      smallText: category.titlePart1,
      bigText: category.titlePart2,
      hover: category.description,
      cta: category.callToAction,
      categoryBackgroundImage: category.images.pageBackground,
      headerColor: category.colors.header,
      headerImage: category.images.pageHeader,
      backgroundColor: category.colors.background,
      backgroundImage: isWide(index) ?
        category.images.wideBackground :
        category.images.squareBackground,
      hoverBackgroundColor: category.colors.hoverBackground,
      hoverBackgroundImage: isWide(index) ?
        category.images.hoverWideBackground :
        category.images.hoverSquareBackground,
      appsCount: category.appCount,
      label: category.label,
      description: category.description
    };

    result.push(Object.assign({}, category, obj));
  });
  return result;
}

export function getCategoryData(categories, pathname, formatMessage) {
  const cats = transformForMenu(categories.menu.items.concat(categories.home.items));

  const category = _.find(cats, i => i.slug === pathname) || {};
  return specialTransformer(pathname, category, cats, formatMessage);
}

// TODO remove this function when RedirectToOneAppMarket merged
function specialTransformer(pathname, category, categories, formatMessage) {
  const all = _.find(categories, i => i.slug === 'all-apps') || {};
  const business = _.find(categories, i => i.slug === 'business-tools-1') || {};
  const free = _.find(categories, i => i.slug === 'free') || {};
  const store = _.find(categories, i => i.slug === 'ecommerce') || {};
  const photography = _.find(categories, i => i.slug === 'photography') || {};
  const marketing = _.find(categories, i => i.slug === 'drive-traffic') || {};

  switch (pathname) {
    case 'main':
      return Object.assign({}, all, {
        slug: 'main',
        smallText: false,
        name: all.nameAlternative,
        hover: all.descriptionAlternative,
        description: all.descriptionAlternative,
        headerColor: all.colors && all.colors.headerAlternative,
        headerImage: all.images && all.images.pageHeaderAlternative
      });

    case 'new':
      return {
        slug: 'new',
        name: formatMessage({id: 'category.new.name'}),
        description: formatMessage({id: 'temp.category.new.desc'}),
        hover: formatMessage({id: 'temp.category.new.desc'}),
        headerColor: '#D18B0B'
      };

    case 'popular':
      return {
        slug: 'popular',
        name: formatMessage({id: 'category.popular.name'}),
        description: formatMessage({id: 'temp.category.popular.desc'}),
        hover: formatMessage({id: 'temp.category.popular.desc'}),
        headerColor: '#288E92'
      };

    case 'all':
      return Object.assign({}, all, {
        smallText: false,
        slug: 'all'
      });

    case 'business':
      return Object.assign({}, business, {
        smallText: false,
        name: formatMessage({id: 'category.business.name'}),
        slug: 'business'
      });

    case 'free-apps':
      return Object.assign({}, free, {
        slug: 'free-apps'
      });

    case 'online-store':
      return Object.assign({}, store, {
        slug: 'online-store'
      });

    case 'galleries':
      return Object.assign({}, photography, {
        slug: 'galleries',
        smallText: false,
        name: formatMessage({id: 'temp.category.galleries.name'}),
      });

    case 'marketing-tools-3':
      return Object.assign({}, marketing, {
        slug: 'marketing-tools-3',
      });

    default:
      return category;
  }
}




// WEBPACK FOOTER //
// ./services/category-transformer.js